import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import type { AuthType } from "src/auth/utils/session";
import { useAuthProviders } from "src/auth/contexts/AuthContext";
import { Skeleton } from "src/components/Skeleton/Skeleton";
import { GoogleSignIn } from "../GoogleSignIn/GoogleSignIn";

export function GoogleSignInButton() {
  const { googleLoading } = useAuthProviders();
  function handleClick() {
    const authType: AuthType = "google";
    sendAnalyticsInteractionEvent({
      category: "UserAccount",
      action: "Click:ThirdPartyAuthButton",
      label: authType,
    });
  }

  if (googleLoading) {
    return <Skeleton height="44px" width="100%" />;
  }

  return <GoogleSignIn onClick={handleClick} />;
}
